import React from "react";
import { Field, useFormikContext } from "formik";
import styles from "./PaymentDataInputs.module.scss";
import { isDiscountValid } from "../../../utils/discountHelper";
const partsOptions = [3, 4, 5];

const formatPrice = (value) => {
  return `${Number(value || 0).toFixed(2)} грн`;
};

const getItemPrice = (cartItem) => {
  const productPrice = Number(cartItem?.product?.currentPrice || cartItem?.currentPrice || 0);

  let discount = 0;

  if (cartItem?.product?.discount > 0) {
    discount = Number(cartItem.product.discount) / 100;
  } else if (
    cartItem?.product?.categories?.discount?.quantity > 0 &&
    isDiscountValid(cartItem.product.categories.discount)
  ) {
    discount = Number(cartItem.product.categories.discount.quantity) / 100;
  }

  return productPrice * (1 - discount);
};

const getCartTotal = (products = []) => {
  return products.reduce((total, item) => {
    const quantity = Number(item.cartQuantity || 1);

    const productTotal = getItemPrice(item) * quantity;
    const bottleTotal = Number(item.bottleCost?.totalCost || 0);

    return total + productTotal + bottleTotal;
  }, 0);
};

const getPluralForm = (count) => {
  if (count === 3 || count === 4) return "платежі";
  return "платежів";
};

const PaymentDataInputs = ({ products = [] }) => {
  const { values } = useFormikContext();
  console.log(products)

  const total = getCartTotal(products);
  console.log("SSSSSS")
  console.log("SSSSSS")
  console.log(total)

  console.log("SSSSSS")
  const selectedParts = Number(values.monoPartsCount || 3);
  const currentMonthlyPayment = total / selectedParts;

  return (
    <div className={styles.container}>
      <label htmlFor="paymentMonoPay" className={styles.paymentOption}>
        <Field
          type="radio"
          name="paymentMethod"
          value="MonoPay"
          id="paymentMonoPay"
        />

        <div className={styles.monoPayButton}>
          <span className={styles.mono}>mono</span>
          <span className={styles.pay}>Pay</span>
        </div>
      </label>

      <label htmlFor="paymentMonoCredit" className={styles.paymentOption}>
        <Field
          type="radio"
          name="paymentMethod"
          value="MonoCredit"
          id="paymentMonoCredit"
        />

        <div className={styles.creditText}>
          Покупка частинами monobank
        </div>
      </label>

      {values.paymentMethod === "MonoCredit" && (
        <div className={styles.installmentsContainer}>
          <label htmlFor="monoPartsCount" className={styles.installmentsTitle}>
            Оберіть кількість платежів
          </label>
       
          <div className={styles.selectWrapper}>
            <Field
              as="select"
              name="monoPartsCount" 
              id="monoPartsCount"
              className={styles.installmentsSelect}
            >
              {partsOptions.map((parts) => (
                <option key={parts} value={String(parts)}>
                  {parts} {getPluralForm(parts)} — {formatPrice(total / parts)}/міс
                </option>
              ))}
            </Field>
          </div>

          <div className={styles.monthlyTotalCalculation}>
            Щомісячний платіж: <strong>{formatPrice(currentMonthlyPayment)}</strong>
          </div>
          <div className={styles.monoInfo}>
            <div className={styles.monoInfoTitle}>
              Покупка частинами monobank
            </div>

            <p className={styles.monoInfoText}>
              Перший платіж списується під час оформлення покупки.
              Наступні платежі — щомісячно рівними частинами.
            </p>

            <p className={styles.monoInfoText}>
              Доступно від 3 до 5 платежів залежно від суми замовлення та ліміту клієнта.
            </p>

            <a href="/payment-installments" target="_blank" className={styles.monoInfoLink}>
              Детальні умови покупки частинами
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentDataInputs;